import { createTypes } from "reduxsauce";

export default createTypes(
    `
    SET_DEALER_INFO
    GET_DEALER_INFO_STARTED
    GET_DEALER_INFO_SUCCESS
    GET_DEALER_INFO_FAILED
    UPDATE_DEALER_SSR_STATUS
    FETCH_DEALER_CMS_CONFIG
    FETCH_DEALER_CMS_CONFIG_SUCCESS
    FETCH_DEALER_CMS_CONFIG_FAILURE
    GET_DEALER_CONFIG_STARTED
    GET_DEALER_CONFIG_SUCCESS
    GET_DEALER_CONFIG_FAILED
    FETCH_DEALER_INVENTORY_STARTED
    FETCH_DEALER_INVENTORY_SUCCESS
    FETCH_DEALER_INVENTORY_FAILED
    RESET_DEALER_INVENTORY
`,
    {
        prefix: "dealer/"
    }
);
